/** Keep in sync with backend/file_types.py */
export const ACCEPTED_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg', '.eml', '.doc', '.docx'];

export const ACCEPT_INPUT =
  '.pdf,.png,.jpg,.jpeg,.eml,.doc,.docx,application/pdf,image/png,image/jpeg,message/rfc822,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword';

export const ACCEPT_LABEL = 'PDF, PNG, Word (.doc/.docx), or EML';

export function isAcceptedFile(file) {
  if (!file) return false;
  const name = (file.name || '').toLowerCase();
  if (ACCEPTED_EXTENSIONS.some((ext) => name.endsWith(ext))) return true;
  const type = (file.type || '').toLowerCase();
  return (
    type === 'application/pdf'
    || type.startsWith('image/png')
    || type.startsWith('image/jpeg')
    || type === 'message/rfc822'
    || type.includes('wordprocessingml')
    || type === 'application/msword'
  );
}
